import React from "react";
import {
  Card,
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  Alert,
} from "../../components/ui";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { loginUser, getSubscriptionStatus } from "../../api";
import { handleApiError } from "../../utils/apiErrorHandler";
import { StyledLoginButton } from "./styled";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      session: null,
      user: null,
      username: "",
      password: "",
    };
  }

  changeUsername = (event) => {
    this.setState({
      username: event.target.value,
    });
  };

  changePassword = (event) => {
    this.setState({
      password: event.target.value,
    });
  };

  processLogin = async () => {
    var data = {
      email: this.state.username,
      password: this.state.password,
    };
    const res = await loginUser(data);
    if (res && res.status >= 200 && res.status < 300) {
      localStorage.setItem("session", JSON.stringify(res.data.token));
      this.setState({
        session: res,
      });
      this.getProfile(res.data);
    } else {
      const errorResponse = handleApiError(res, "Login failed");
      this.setState({
        showError: true,
        errorText: errorResponse.message,
      });
    }
  };

  getProfile = (session) => {
    fetch(process.env.REACT_APP_API_URL + "user/" + session.userId, {
      headers: {
        "Content-Type": "application/json",
        "X-Auth-Token": session.token,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        localStorage.setItem("user", JSON.stringify(data));
        this.setState({
          authenticated: true,
          user: data,
        });
        // Logged in
        if (Notification.permission === "default") {
          Notification.requestPermission((permission) => {});
        }

        try {
          const { data: subscriptionData } = await getSubscriptionStatus(
            data && data.id
          );
          if (subscriptionData && subscriptionData.subscriptionStatusId === 4) {
            window.location.href = "/user-profile?tab=billing";
          }
        } catch (error) {}
      })
      .catch((error) => {});
  };

  keyPress = (e) => {
    if (e.keyCode === 13) {
      this.processLogin();
    }
  };

  render() {
    return (
      <Col className={"boxCard"} sm={{ size: 4, offset: 4 }}>
        <Card small className="mb-4 p-4">
          <Row>
            <Col>
              <Form>
                <FormGroup className="form-group">
                  <label htmlFor="feCurrPass">Email</label>
                  <FormInput
                    id="feCurrPass"
                    type="text"
                    placeholder="Email"
                    value={this.state.username}
                    onChange={this.changeUsername}
                    onKeyDown={this.keyPress}
                  />
                </FormGroup>
                <FormGroup className="form-group">
                  <label htmlFor="feCurrPass">Password</label>
                  <FormInput
                    id="feNewPass"
                    type="password"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={this.changePassword}
                    onKeyDown={this.keyPress}
                  />
                </FormGroup>
                <StyledLoginButton
                  onClick={(e) => {
                    e.preventDefault();
                    this.processLogin();
                  }}
                >
                  Login
                </StyledLoginButton>
                {this.state.authenticated && (
                  <Navigate to="/blogs/premium/" replace />
                )}
              </Form>
              <br />
              <Link to={"/prices"}>Not a member? Sign up.</Link>
              <br />
              <Link to={"/forgot"}>Forgot password?</Link>
              <br />
              <br />
              {this.state.showError && (
                <Alert className="mb-0">
                  <i className="fa fa-error mx-2"></i>
                  {this.state.errorText}
                </Alert>
              )}
            </Col>
          </Row>
        </Card>
      </Col>
    );
  }
}

export default Login;
